<template>
  <div class="disease-title-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DiseaseTitle',
  components: {},
  props: {},
  data() {
    return  {};
  },
  methods: {},
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.disease-title-container {
  background-image: url("../assets/image/diseasePage/DiseaseTitle.png");
  background-size: 100% 100%;
  color: #0fffff;
  font-size: 5.5vw;
  font-family: "PingFang",serif;
  padding: 3vw 0 4.5vw 0;
  margin: 20vw 28vw 0 28vw;
}
</style>
